import { Component, OnInit } from '@angular/core';
import { StoreService } from './store.service'; 
import * as $ from "jquery";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor( private $store : StoreService ) {}
      
  ngOnInit() {
  }

  getRouterValue() {
    console.log('this.$store.router.profile', this.$store.router.profile)
    return this.$store.router.profile
  }
}



// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/app.component.ts